import { Typography } from 'antd';
import { TitleDivider } from '../divider/style/TitleDivider.tsx';

export function PageBreakPreviewComponent() {
  return (
    <TitleDivider>
      <div>Divisore di Pagina</div>
      <Typography.Text>
        Questo elemento non è visibile in compilazione.
      </Typography.Text>
    </TitleDivider>
  );
}
